export const TYPE_TEXT = 0;
export const TYPE_IMAGE = 1;
export const TYPE_VIDEO = 2;
export const TYPE_STORY = 3;
export const TYPE_AWARDS = 4;
export const TYPE_BUTTONLIST = 6;



// WEBPACK FOOTER //
// src/utils/case-types.js